import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const empty = { slug: "", name: "", duration_days: 30, price_try: 149, price_usd: 5.99, monthly_tokens: 300, features: [], is_active: true, sort_order: 10 };

export default function AdminPlans() {
  const [plans, setPlans] = useState([]);
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);

  const load = () => api.get("/admin/premium-plans", adminApi()).then(({ data }) => setPlans(data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (creating) await api.post("/admin/premium-plans", editing, adminApi());
      else await api.patch(`/admin/premium-plans/${editing.id}`, editing, adminApi());
      toast.success("Kaydedildi");
      setEditing(null); setCreating(false);
      load();
    } catch { toast.error("Hata"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/premium-plans/${id}`, adminApi());
    load();
  };

  return (
    <div className="font-admin-body">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-admin-head text-3xl">Premium Planlar</h1>
        <button onClick={() => { setCreating(true); setEditing({ ...empty }); }} className="admin-btn flex items-center gap-2"><Plus className="w-4 h-4" /> Yeni Plan</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {plans.map((p) => (
          <div key={p.id} className="admin-card p-4">
            <div className="flex items-start justify-between mb-2">
              <div>
                <div className="font-admin-head text-xl">{p.name}</div>
                <div className="text-xs text-white/50">{p.slug} · {p.duration_days} gün</div>
              </div>
              <div className="flex gap-1">
                <button onClick={() => setEditing({ ...p })} className="admin-btn-ghost text-xs px-2 py-1">Düzenle</button>
                <button onClick={() => remove(p.id)} className="admin-btn-ghost text-xs px-2 py-1 text-red-400"><Trash2 className="w-3 h-3" /></button>
              </div>
            </div>
            <div className="text-sm">${p.price_usd} / {p.price_try}₺ · +{p.monthly_tokens} jeton</div>
            <ul className="text-xs text-white/60 mt-2 space-y-0.5">
              {(p.features || []).map((f, i) => <li key={i}>• {f}</li>)}
            </ul>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 p-4">
          <div className="admin-card p-6 w-full max-w-lg">
            <h2 className="font-admin-head text-xl mb-4">{creating ? "Yeni Plan" : "Plan Düzenle"}</h2>
            <div className="grid grid-cols-2 gap-3">
              {creating && (<div className="col-span-2"><label className="text-xs text-white/50">Slug</label><input value={editing.slug} onChange={(e) => setEditing({ ...editing, slug: e.target.value })} className="admin-input" /></div>)}
              <div className="col-span-2"><label className="text-xs text-white/50">Ad</label><input value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className="admin-input" /></div>
              <div><label className="text-xs text-white/50">Gün</label><input type="number" value={editing.duration_days} onChange={(e) => setEditing({ ...editing, duration_days: parseInt(e.target.value) || 0 })} className="admin-input" /></div>
              <div><label className="text-xs text-white/50">Aylık Jeton</label><input type="number" value={editing.monthly_tokens} onChange={(e) => setEditing({ ...editing, monthly_tokens: parseInt(e.target.value) || 0 })} className="admin-input" /></div>
              <div><label className="text-xs text-white/50">Fiyat (₺)</label><input type="number" step="0.01" value={editing.price_try} onChange={(e) => setEditing({ ...editing, price_try: parseFloat(e.target.value) || 0 })} className="admin-input" /></div>
              <div><label className="text-xs text-white/50">Fiyat ($)</label><input type="number" step="0.01" value={editing.price_usd} onChange={(e) => setEditing({ ...editing, price_usd: parseFloat(e.target.value) || 0 })} className="admin-input" /></div>
              <div className="col-span-2"><label className="text-xs text-white/50">Özellikler (satır satır)</label><textarea value={(editing.features || []).join("\n")} onChange={(e) => setEditing({ ...editing, features: e.target.value.split("\n").filter(Boolean) })} rows={4} className="admin-input" /></div>
              <label className="col-span-2 flex items-center gap-2 text-sm"><input type="checkbox" checked={!!editing.is_active} onChange={(e) => setEditing({ ...editing, is_active: e.target.checked })} className="accent-[#F59E0B]" /> Aktif</label>
            </div>
            <div className="flex gap-2 mt-6">
              <button onClick={save} className="admin-btn flex-1">Kaydet</button>
              <button onClick={() => { setEditing(null); setCreating(false); }} className="admin-btn-ghost flex-1">İptal</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
